<template>
    <md-icon class="md-icon-image" v-once>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <g>
                <circle cx="256" cy="256" r="256" fill="#C01537"/>
                <path fill="#FFFFFF" class="cls-2" d="M401.7,219.6H110.3A24.33,24.33,0,0,0,86,243.9v24.3a24.33,24.33,0,0,0,24.3,24.3H401.7A24.33,24.33,0,0,0,426,268.2V243.9A24.26,24.26,0,0,0,401.7,219.6Z"/>
            </g>
        </svg>
    </md-icon>
</template>

<script>
  import MdIcon from "../../../components/MdIcon/MdIcon";

  export default {
    name: 'GdRemoveItemIcon',
    components: {
      MdIcon
    }
  }
</script>
